import { ActionTypes } from './actions';

export interface InitialState {
  conversations: Array<String>;
  connections: Object;
  activeConversation: Object;
  PushConversation: Object;
  UpdateConversation: Object;
  SetMessageRead: String;
  allPosts: Array<Object>;
  allLocations: Array<Object>;
}

export const initialState = {
  conversations: [],
  connections: {},
  activeConversation: {},
  PushConversation: {},
  UpdateConversation: {},
  SetMessageRead: '',
  allPosts: [],
  allLocations: []
};

export function ShopReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.Add:
      return {
        ...state,
        conversations: action.payload
      };

    case ActionTypes.GetConnections:
      return {
        ...state,
        connections: action.payload
      };

    case ActionTypes.SetActiveConversation:
      return {
        ...state,
        activeConversation: action.payload
      };

    case ActionTypes.PushConversation:
      return {
        ...state,
        conversations: [...state.conversations, action.payload]
      };

    case ActionTypes.SetMessageRead:
      return {
        ...state,
        conversations: state.conversations.map((conversation: any) => {
          if (conversation['_id'] === action.payload) {
            return { ...conversation, unReadMessagesCount: 0 };
          }
          return conversation;
        })
      };

    case ActionTypes.UpdateConversation:
      return {
        ...state,
        conversations: state.conversations.map((conversation: any) => {
          if (conversation['_id'] === action.payload.message_obj.room_id) {
            const existing: any[] = conversation['messages'] || [];
            const alreadyExists = existing.some((m: any) => m._id === action.payload.message_obj._id);
            return {
              ...conversation,
              unReadMessagesCount: (conversation['unReadMessagesCount'] || 0) + 1,
              messages: alreadyExists ? existing : [...existing, action.payload.message_obj],
              latestMessage: action.payload.message_obj.message,
              latestMessageTime: action.payload.message_obj.created_date_time?.$date
            };
          }
          return conversation;
        })
      };

    case ActionTypes.SetAds:
      return {
        ...state,
        allPosts: action.payload
      };

    case ActionTypes.SetLocations:
      return {
        ...state,
        allLocations: action.payload
      };

    default:
      return state;
  }
}
